import axios from "axios";
export const misMixins = {
  data() {
    return {
      ebaConfig: null,
    };
  },
  methods: {
    async loadEbaConfig() {
      let config = null;
      try {
        config = await axios.get("../config.js");
      } catch (error) {
        config = await axios.get("@/../public/config.js");
      }
      this.ebaConfig = eval(config.data);
      //console.log(this.ebaConfig);
      return this.ebaConfig;
    },
    cargarConfig() {
      const me = this;
      const instance = axios.create({
        baseURL: "",
      });
      return new Promise((resolve, reject) => {
        instance
          .get("../config.js", {})
          .then((response) => {
            me.ebaConfig = eval(response.data);
            resolve(me.ebaConfig);
          })
          .catch(() => {
            return new Promise((resolve, reject) => {
              instance
                .get("@/../public/config.js")
                .then((response) => {
                  me.ebaConfig = eval(response.data);
                  resolve(me.ebaConfig);
                })
                .catch((error) => {
                  reject(error);
                });
            });
          });
      });
    },
  },
};
